import classNames from 'classnames';
import { parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import DatesRange from './DatesRange';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/draw-dates.module.scss';

const propTypes = {
    draw: AppPropTypes.draw.isRequired,
    withoutBatch: PropTypes.bool,
    className: PropTypes.string,
    batchClassName: PropTypes.string,
};

const defaultProps = {
    withoutBatch: false,
    className: null,
    batchClassName: null,
};

function DrawDates({ draw, withoutBatch, className, batchClassName }) {
    const intl = useIntl();
    const {
        type = null,
        startAt = null,
        endAt = null,
        drawingWeekday = null,
        drawingAt = null,
        batch: currentBatch = null,
        batches = [],
    } = draw;

    const {
        id: currentBatchId = null,
        startAt: currentBatchStartAt = null,
        endAt: currentBatchEndAt = null,
        drawingAt: currentBatchDrawingAt = null,
    } = currentBatch || {};
    const currentBatchIndex =
        batches !== null ? batches.findIndex(({ id }) => id === currentBatchId) : -1;

    const drawingAtDate = useMemo(
        () =>
            drawingAt !== null || currentBatchDrawingAt !== null
                ? parseISO(currentBatchDrawingAt || drawingAt)
                : null,
        [currentBatchDrawingAt, drawingAt],
    );
    const startAtDate = useMemo(() => (startAt !== null ? parseISO(startAt) : null), [startAt]);
    if (drawingAt === null) {
        return null;
    }
    let drawingDate = null;
    if (drawingWeekday !== null) {
        drawingDate = withoutBatch ? (
            <FormattedMessage
                defaultMessage="Next draw on {drawing_at}"
                description="Draw weekday"
                values={{
                    drawing_at: intl.formatDate(drawingAtDate, {
                        day: 'numeric',
                        month: 'long',
                    }),
                }}
            />
        ) : (
            <FormattedMessage
                defaultMessage="Draw every {drawing_weekday}"
                description="Draw weekday"
                values={{
                    drawing_weekday: drawingWeekday,
                    drawing_at: intl.formatDate(drawingAtDate, {
                        day: 'numeric',
                        month: 'long',
                    }),
                }}
            />
        );
    } else if (type === 'daily') {
        drawingDate = (
            <FormattedMessage
                defaultMessage="Draws starting on {date}"
                description="Draw date"
                values={{
                    date: intl.formatDate(startAtDate, {
                        day: 'numeric',
                        month: 'long',
                    }),
                }}
            />
        );
    } else if (drawingAtDate !== null) {
        drawingDate = (
            <FormattedMessage
                defaultMessage="Draw on {drawing_at}"
                description="Draw date"
                values={{
                    drawing_at: intl.formatDate(drawingAtDate, {
                        day: 'numeric',
                        month: 'long',
                        // year: 'numeric',
                    }),
                }}
            />
        );
    }
    if (drawingDate === null) {
        return null;
    }
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            <div className={styles.drawDates}>
                <div className={styles.drawingDate}>{drawingDate}</div>
                {type === 'weekly' && currentBatch !== null && !withoutBatch ? (
                    <div
                        className={classNames([
                            styles.batch,
                            {
                                [batchClassName]: batchClassName !== null,
                            },
                        ])}
                    >
                        <FormattedMessage
                            defaultMessage="<strong>Week {index}</strong> : {date}"
                            values={{
                                index: currentBatchIndex !== -1 ? currentBatchIndex + 1 : '',
                                date: (
                                    <>
                                        &nbsp;
                                        <DatesRange
                                            startAt={currentBatchStartAt || startAt}
                                            endAt={currentBatchEndAt || endAt}
                                            className={styles.range}
                                        />
                                    </>
                                ),
                            }}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
}

DrawDates.propTypes = propTypes;
DrawDates.defaultProps = defaultProps;

export default DrawDates;
